import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// CSS-in-JS スタイル
const styles = {
  bottomNav: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'white',
    borderTop: '1px solid #eee',
    zIndex: 1000
  },
  footerMenu: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'space-around',
    background: 'white'
  },
  footerMenuItem: {
    flex: 1,
    textAlign: 'center',
    padding: '10px 0'
  },
  footerMenuDiv: {
    cursor: 'pointer',
    fontSize: '12px',
    color: '#666',
    transition: 'color 0.3s ease',
    textAlign: 'center'
  },
  footerMenuDivActive: {
    color: '#F93535',
    fontWeight: 'bold'
  },
  footerMenuIcon: {
    width: '24px',
    height: '24px',
    margin: '0 auto 4px',
    display: 'block',
    verticalAlign: 'middle'
  },
  footerMenuIconActive: {
    width: '24px',
    height: '24px',
    margin: '0 auto 4px',
    display: 'block',
    verticalAlign: 'middle',
    filter: 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)'
  },
};

const Footer = ({ onFooterClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // フッターメニューアイテム定義
  const footerMenuItems = [
    { 
      path: '/appTop', // パス
      label: 'HOME', // 表示ラベル
      icon: '/core/img/home.png', // アイコン画像パス
      className: 'appTop' // CSSクラス名
    },
    { 
      path: '/appSatsuei', 
      label: '撮影', 
      icon: '/core/img/icon/photo-camera.png',
      className: 'appSatsuei'
    },
    { 
      path: '/appSearch', 
      label: '検索', 
      icon: '/core/img/magnifier.png',
      className: 'appSearch'
    },
    { 
      path: '/appConfig', 
      label: '設定', 
      icon: '/core/img/settings-gears.png',
      className: 'appConfig'
    }
  ];

  // フッターメニューナビゲーション処理
  const handleFooterNavigation = (path) => {
    // ObjectDetail画面が表示されている場合はクリアしてから遷移
    if (onFooterClick) {
      onFooterClick(path);
    } else {
      navigate(path);
    }
  };

  // アクティブ状態判定処理
  const isActive = (path) => {
    // パスが完全に一致する場合のみアクティブ
    // ただし、設定アイコンはAppUserInfo画面でもアクティブにする
    if (path === '/appConfig') {
      return location.pathname === '/appConfig' || location.pathname === '/appUserInfo';
    }
    return location.pathname === path;
  };

  return (
    <div style={styles.bottomNav} role="navigation" aria-label="フッターメニュー">
      <ul style={styles.footerMenu}>
        {footerMenuItems.map((item, index) => {
          const active = isActive(item.path);
          return (
            <li
              key={index}
              style={styles.footerMenuItem}
              onClick={() => handleFooterNavigation(item.path)}
              className={item.className}
              role="menuitem"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleFooterNavigation(item.path);
                }
              }}
            >
              <div style={{
                ...styles.footerMenuDiv,
                ...(active ? styles.footerMenuDivActive : {})
              }}>
                <img
                  src={item.icon}
                  alt={item.label}
                  style={active ? styles.footerMenuIconActive : styles.footerMenuIcon}
                  onError={(e) => {
                    // アイコンが読み込めない場合は非表示
                    e.target.style.display = 'none';
                  }}
                />
                {item.label}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Footer;
